<template>
  <div class="chartContainer placeholder flexCenterCenter">
    <div v-if="downloading">
      <div class="spinnerContainer">
        <Spinner />
      </div>
      <div class="spinnerText">
        Getting data
      </div>
    </div>
    <div v-else>
      <div>Data not loaded</div>
    </div>
  </div>
</template>

<script>

import Spinner from './Spinner'

export default {
  name: 'ChartPlaceholder',
  components: {
    Spinner,
  },
  props: {
    downloading: {
      type: Boolean,
      required: true,
    },
  },
}

</script>
